import logoFormic from "../../../assets/icons/logoformic.webp";

export default function AdminLayoutGlobalLoading() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="flex h-24 w-24 items-center justify-center rounded-2xl bg-white p-4 shadow-lg animate-pulse">
        <img
          src={logoFormic}
          alt="سپهرجو"
          className="h-full w-full object-contain"
        />
      </div>
    </div>
  );
}